export var HeaderMode;
(function (HeaderMode) {
    HeaderMode[HeaderMode["DEFAULT"] = 0] = "DEFAULT";
    HeaderMode[HeaderMode["CUSTOM"] = 1] = "CUSTOM";
})(HeaderMode || (HeaderMode = {}));
export var FooterMode;
(function (FooterMode) {
    FooterMode[FooterMode["DEFAULT"] = 0] = "DEFAULT";
    FooterMode[FooterMode["EXTENDED"] = 1] = "EXTENDED";
})(FooterMode || (FooterMode = {}));
//# sourceMappingURL=header-footer-settings.js.map